import StoreConfigImage from '../../form-elements/StoreConfigImage';
import { StoreConfigWidgetProps } from '../../types/store-config-widget';

function StoreConfigImageWidget(props: StoreConfigWidgetProps) {
  return (
    <StoreConfigImage
      value={props.value}
      onChange={props.onChange}
      path={props.options?.path}
      onFocus={props.onFocus}
      id={props.id}
    />
  );
}

export default StoreConfigImageWidget;
